// extracted by mini-css-extract-plugin
module.exports = {"root":"footer_root__1F9TO","wrapper":"footer_wrapper__1k81-","logo":"footer_logo__3Op2T","col":"footer_col__1Dj69"};